
export const CSRF_TOKEN_KEY = 'csrf';

export const USER_KEY = 'user';

export const ACCESS_TOKEN_KEY = 'access_token';

export const LOCALE_KEY = 'locale';

export const SESSION_COOKIE_KEY = 'session';

export const CUSTOMER_ID_KEY = 'customerId';

export const CACHED_HEADER_CATEGORY_KEY = 'cached_header_category';

export const USER_ICON_KEY = 'user_icon';

export const PROVIDE_CATEGORY_MODAL_KEY = 'provide_category_modal_key';

export const FAVORITE_ITEM_KEY = 'favorite';

export const HOMEPAGE_ID = '1eed0b00-9833-67c0-5828-ebe6324069f0';

export const PROVIDE_DARK_BG = 'show_dark_bg';

export const STORE_CITYID_KEY = 'cityId';
export const STORE_STATEID_KEY = 'stateId';

export const IS_LOGIN_BY_GOOGLE = 'isLoginByGoogle';